import { Box } from "@mui/material";
import { sourceCardStyles } from "../PublicRiskObservation.styles";

export interface ISourceCardProps {
    name: string;
    helperText: string;
    emoji: string;
    isSelected: boolean;
    onClick: () => void;
}

function SourceCard({ name, helperText, emoji, isSelected, onClick }: ISourceCardProps) {
    return (
        <Box
            component="button"
            type="button"
            role="radio"
            aria-checked={isSelected}
            onClick={onClick}
            sx={[sourceCardStyles.card, isSelected && sourceCardStyles.cardSelected]}
        >
            <Box sx={sourceCardStyles.iconTile} aria-hidden>
                {emoji}
            </Box>
            <Box sx={sourceCardStyles.textBlock}>
                <Box sx={sourceCardStyles.name}>{name}</Box>
                <Box sx={sourceCardStyles.helperText}>{helperText}</Box>
            </Box>
            <Box sx={[sourceCardStyles.radio, isSelected && sourceCardStyles.radioSelected]}>{isSelected && <Box sx={sourceCardStyles.radioDot} />}</Box>
        </Box>
    );
}

export default SourceCard;
